import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, Drawer, IconButton, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { Colors } from 'src/components/utils/Theme';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  children?: ReactNode;
}

/**
 * Right-anchored, closable slide-in used to show record details next to a list,
 * instead of dumping the record below the table.
 */
export const DetailDrawer: FC<Props> = ({ open, onClose, title, children }) => {
  return (
    <Drawer
      anchor="right"
      variant="temporary"
      open={open}
      onClose={onClose}
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
      PaperProps={{ sx: { width: { xs: '100%', sm: 560 }, maxWidth: '100%' } }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5 }}>
        <Typography variant="h6" style={{ fontFamily: 'Aestetico-semibold', color: Colors.BLACK_BLUE }}>
          {title}
        </Typography>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <Box sx={{ p: 2, overflowY: 'auto', flex: 1 }}>{children}</Box>
    </Drawer>
  );
};
